import { extendObservable, action } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { get, mapValues } from 'lodash';
import { isRequired, isCNPJ, isCPF } from '../../../core/validations';
import { BRAZIL } from '../../../core/consts';

export default class CompanyFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      companyId: null,
    });
    this.form.validations = {
      name: [isRequired],
      country: [isRequired],
      state: [isRequired],
      distributor: [isRequired],
      cnpj: [isRequired],
      isCertificationTestDisabled: [isRequired],
    };
  }

  onChange = (path, value) => {
    if (path === 'cnpj' && BRAZIL.includes(get(this.form.getValues(), 'country', ''))) {
      if (get(this.form.getValues(), 'cnpj', '').length > 11) {
        this.form.validations.cnpj = [isRequired, isCNPJ];
      } else {
        this.form.validations.cnpj = [isRequired, isCPF];
      }
    }
    if (path === 'country' && BRAZIL.includes(value)) {
      this.form.validations.cnpj = [isRequired];
    }
    if (path === 'distributor') {
      this.handleValidationsByDistributor(value);
    }
    this.form.setValue(path, value);
  };

  handleValidationsByDistributor = action((distributor) => {
    if (distributor && distributor.name.toLowerCase() === 'flexge') {
      this.form.validations.segment = [isRequired];
    } else {
      delete this.form.validations.segment;
    }
  });

  handleLoad = action((companyId, distributorId) => {
    this.form.reset();
    if (companyId) {
      this.fetch
        .fetch({
          url: `/companies/${companyId}`,
          query: {
            populateProps: ['distributor'],
          },
        })
        .then(() => {
          if (this.fetch.data) {
            const initialValues = this.fetch.data;
            if (initialValues.contractStart) {
              initialValues.contractStart = new Date(initialValues.contractStart);
            }
            if (initialValues.contractEnd) {
              initialValues.contractEnd = new Date(initialValues.contractEnd);
            }
            if (
              initialValues.isCertificationTestDisabled === null ||
              initialValues.isCertificationTestDisabled === undefined
            ) {
              initialValues.isCertificationTestDisabled = false;
            }
            if (initialValues.distributor.name.toLowerCase() === 'flexge') {
              this.form.validations.segment = [isRequired];
            }
            this.form.setInitialValues(initialValues);
          }
        });
    } else {
      this.form.setInitialValues({
        ...(distributorId && {
          distributor: distributorId,
        }),
        ...(localStorage.role === 'DISTRIBUTOR_MANAGER' && {
          distributor: localStorage.distributor,
        }),
        isCertificationTestDisabled: false,
      });
    }
    this.companyId = companyId;
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }
    const companyId = this.form.getValue('id');
    this.submit
      .fetch({
        method: companyId ? 'put' : 'post',
        url: companyId ? `/companies/${companyId}` : '/companies',
        body: {
          ...mapValues(this.form.getValues(), (value) => (value === '' ? null : value)),
          distributor: this.form.getValue('distributor.id'),
        },
      })
      .then(() => {
        if (this.submit.data) {
          const company = this.submit.data;
          this.companyId = company.id;
          if (company.contractStart) {
            company.contractStart = new Date(company.contractStart);
          }
          if (company.contractEnd) {
            company.contractEnd = new Date(company.contractEnd);
          }
          this.fetch
            .fetch({
              url: `/distributors/${company.distributor}`,
            })
            .then(() => {
              if (this.fetch.data) {
                this.form.setInitialValues({
                  ...company,
                  distributor: this.fetch.data,
                });
                this.form.reset();
              }
            });
          NotificationService.addNotification(`Company ${companyId ? 'updated' : 'created'} successfully.`, 'success');
        }
        if (this.submit.error) {
          NotificationService.addNotification(`Error ${companyId ? 'updating' : 'creating'} company.`, 'error');
        }
      });
  });
}
